"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalNumberRequest = exports.GlobalNumberPutRequest = exports.GlobalNumberPostRequest = exports.MigrationRequest = exports.MigrationPutRequest = exports.MigrationPostRequest = exports.ExportRequest = exports.ExportPutRequest = exports.ExportPostRequest = exports.EmailPut = exports.DDIProvision = exports.NotePost = exports.NotePut = exports.Note = exports.Comment = exports.CommentPut = exports.CommentPost = exports.AssignmentRequest = exports.AssignmentPutRequest = exports.AllocationRequest = exports.AllocationPutRequest = exports.AllocationPostRequest = exports.TicketFilterRequest = exports.Ticket = exports.PortingPostRequest = exports.PortSubmissionPut = exports.PortSubmissionPost = exports.PortSubmission = exports.PortStatusPut = exports.PortStatusPost = exports.PortStatus = exports.PortRequest = void 0;
const AllocationPostRequest_1 = require("./AllocationPostRequest");
exports.AllocationPostRequest = AllocationPostRequest_1.default;
const AllocationPutRequest_1 = require("./AllocationPutRequest");
exports.AllocationPutRequest = AllocationPutRequest_1.default;
const AllocationRequest_1 = require("./AllocationRequest");
exports.AllocationRequest = AllocationRequest_1.default;
const AssignmentPutRequest_1 = require("./AssignmentPutRequest");
exports.AssignmentPutRequest = AssignmentPutRequest_1.default;
const AssignmentRequest_1 = require("./AssignmentRequest");
exports.AssignmentRequest = AssignmentRequest_1.default;
const Comment_1 = require("./Comment");
exports.Comment = Comment_1.default;
const CommentPost_1 = require("./CommentPost");
exports.CommentPost = CommentPost_1.default;
const CommentPut_1 = require("./CommentPut");
exports.CommentPut = CommentPut_1.default;
const DDIProvision_1 = require("./DDIProvision");
exports.DDIProvision = DDIProvision_1.default;
const EmailPut_1 = require("./EmailPut");
exports.EmailPut = EmailPut_1.default;
const ExportPostRequest_1 = require("./ExportPostRequest");
exports.ExportPostRequest = ExportPostRequest_1.default;
const ExportPutRequest_1 = require("./ExportPutRequest");
exports.ExportPutRequest = ExportPutRequest_1.default;
const ExportRequest_1 = require("./ExportRequest");
exports.ExportRequest = ExportRequest_1.default;
const MigrationPostRequest_1 = require("./MigrationPostRequest");
exports.MigrationPostRequest = MigrationPostRequest_1.default;
const MigrationPutRequest_1 = require("./MigrationPutRequest");
exports.MigrationPutRequest = MigrationPutRequest_1.default;
const MigrationRequest_1 = require("./MigrationRequest");
exports.MigrationRequest = MigrationRequest_1.default;
const Note_1 = require("./Note");
exports.Note = Note_1.default;
const NotePost_1 = require("./NotePost");
exports.NotePost = NotePost_1.default;
const NotePut_1 = require("./NotePut");
exports.NotePut = NotePut_1.default;
const PortRequest_1 = require("./PortRequest");
exports.PortRequest = PortRequest_1.default;
const PortStatus_1 = require("./PortStatus");
exports.PortStatus = PortStatus_1.default;
const PortStatusPost_1 = require("./PortStatusPost");
exports.PortStatusPost = PortStatusPost_1.default;
const PortStatusPut_1 = require("./PortStatusPut");
exports.PortStatusPut = PortStatusPut_1.default;
const PortSubmission_1 = require("./PortSubmission");
exports.PortSubmission = PortSubmission_1.default;
const PortSubmissionPost_1 = require("./PortSubmissionPost");
exports.PortSubmissionPost = PortSubmissionPost_1.default;
const PortSubmissionPut_1 = require("./PortSubmissionPut");
exports.PortSubmissionPut = PortSubmissionPut_1.default;
const PortingPostRequest_1 = require("./PortingPostRequest");
exports.PortingPostRequest = PortingPostRequest_1.default;
const Ticket_1 = require("./Ticket");
exports.Ticket = Ticket_1.default;
const TicketFilterRequest_1 = require("./TicketFilterRequest");
exports.TicketFilterRequest = TicketFilterRequest_1.default;
const GlobalNumberPostRequest_1 = require("./GlobalNumberPostRequest");
exports.GlobalNumberPostRequest = GlobalNumberPostRequest_1.default;
const GlobalNumberPutRequest_1 = require("./GlobalNumberPutRequest");
exports.GlobalNumberPutRequest = GlobalNumberPutRequest_1.default;
const GlobalNumberRequest_1 = require("./GlobalNumberRequest");
exports.GlobalNumberRequest = GlobalNumberRequest_1.default;
